(function() {
    'use strict';

    angular
        .module('app')
        .controller('registerModalController', registerModalController);

    function registerModalController($uibModalInstance, loginService, $rootScope, sysCode,
        e2eService, blockUI, iAmNotRobot) {
        var vm = this;
        vm.cancel = cancel;
        vm.submit = submit;
        vm.autoFill = autoFill;
        vm.iAmNotRobot = iAmNotRobot;

        onInit();

        function onInit() {
            vm.data = {};
            vm.sendType = [
                { id: 1, name: 'Email' },
                { id: 2, name: $rootScope.translate.commonSMS }
            ];
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function specialKeywordVerificationUserAccount(keyWord){
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g,"/");
            var pattern = new RegExp("[/\\/<>'\"()%]");
            var result = false; 
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:'+keyWord.substr(i, 1) +' pattern:'+keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {result=true; }
            } 
            return result;
        }

        function specialKeywordVerification(keyWord){
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】【.】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g,"/");
            var pattern = new RegExp("[/\\/<>'\"()%.]");
            var result = false; 
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:'+keyWord.substr(i, 1) +' pattern:'+keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {result=true; }
            } 
            return result;
        }

        function phoneKeywordVerification(keyWord){
            /*2020-06-11 Johnson
            特殊字元 【0-9】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            var result = false; 
            var str = keyWord.replace(/[^0-9]/g,'false');
            if(str.indexOf('false') != -1)
                result = true; 
            
            return result;
        }
        
        function submit() {

            if(specialKeywordVerificationUserAccount(vm.data.email))
            {
                toastr.warning($rootScope.translate.tsdgLoginAccount + $rootScope.translate.specialKeywords);
                return false;
            }
            else if(specialKeywordVerificationUserAccount(vm.data.cName))
            {
                toastr.warning($rootScope.translate.tsdgName + $rootScope.translate.specialKeywords);
                return false;
            }
            else if(phoneKeywordVerification(vm.data.perTel))
            {
                toastr.warning($rootScope.translate.commonMobile + $rootScope.translate.commonIncorrectFormat);
                return false;
            }
            else if(specialKeywordVerification(vm.login.inputVerify))
            {
                toastr.warning($rootScope.translate.validateCode + $rootScope.translate.specialKeywords);
                return false;
            }

            // Block the user interface
            if($('#inputVerify').val().length == 4){
                blockUI.start();

                vm.data.target = 1;
                vm.data.sysCode = sysCode;

                var params = {
                    cName: vm.data.cName,
                    email: vm.data.email,
                    target: vm.data.target,
                    sysCode: vm.data.sysCode,
                    pwd: vm.data.pwd,
                    perTel: vm.data.perTel,
                    confirmPwd: vm.data.confirmPwd,
                    inputVerify: $('#inputVerify').val().toUpperCase(),
                    isPass: $('#isPass').val(),
                    SecretKey: "1"
                };

                loginService.registerOutsideUser(params).then(function(data) {
                    // Unblock the user interface
                    blockUI.stop();
                    if (data) {
                        toastr.success($rootScope.translate.commonAlreadySendMail);
                        $uibModalInstance.close('ok');
                    }
                });
            }else
            {
                toastr.warning($rootScope.translate.commonReCaptchaFail);
            }
        }

        function autoFill() {
            e2eService.register(vm.data);
        }
    }
})();